<template>
  <div>
    <v-icon :color="isActiveRoute ? 'red' : null" class="icon" size="40">{{
      icon
    }}</v-icon>
    <p :class="{ active: isActiveRoute }">{{ text }}</p>
  </div>
</template>

<script>
export default {
  name: "IconWithText",
  props: {
    to: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
  },
  computed: {
    isActiveRoute() {
      return this.$route.path === this.to;
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  margin: 10px 0;
}

p {
  color: rgba(0, 0, 0, 0.87);
}

.active {
  color: var(--red);
}
</style>
